import type { ModuleDefinition } from '../../../app/moduleRegistry';
import GsaListPage from './pages/GsaListPage';

/** Firma (Acente) yönetimi — Master GSA only. Tam CRUD: list (`Gsa/GetGsaList`), create
 *  (`Gsa/AddGsa`), edit (`Gsa/EditGsa`), delete (`Gsa/DeleteGsa`) — hepsi bağlı. Logo
 *  yükleme best-effort (`Gsa/UploadLogo` swagger'da yok, `EditGsa.logo`'ya düşer). */
export const gsaModule: ModuleDefinition = {
  routes: [{ path: 'system/gsa', element: <GsaListPage /> }],
  menuItems: [
    {
      label: 'Sistem: Firmalar',
      path: 'system/gsa',
      isVisible: (user) => !!user?.isMasterGsa,
    },
  ],
};
